/**
 * Feature flag for the R2 layer-stack render path.
 *
 * The R2 layer-stack path is the default: this returns true unless the build
 * sets VITE_R2_RENDER to a false token, or the URL carries ?r2=0 (the URL wins,
 * so a single build can show both paths). Nothing here touches PixiRenderer.
 *
 * ?r2=0 runs the frozen legacy 16x16 atlas path. ?r2=harness is the separate
 * asset harness — one token, so a URL can only ask for one of them.
 */
const ENV_KEY = 'VITE_R2_RENDER';
const QUERY_KEY = 'r2';
const HARNESS_TOKEN = 'harness';
const TRUE_TOKENS = ['1', 'true', 'on'];
const FALSE_TOKENS = ['0', 'false', 'off'];

function parseToken(raw: string): boolean | null {
  const token = raw.trim().toLowerCase();
  if (TRUE_TOKENS.includes(token)) return true;
  if (FALSE_TOKENS.includes(token)) return false;
  return null;
}

const DEFAULT_R2_ENABLED = true;

function envFlag(): boolean | null {
  const raw: unknown = import.meta.env[ENV_KEY];
  return typeof raw === 'string' ? parseToken(raw) : null;
}

function queryToken(): string | null {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get(QUERY_KEY);
}

function queryFlag(): boolean | null {
  const raw = queryToken();
  return raw === null ? null : parseToken(raw);
}

export function isR2RenderEnabled(): boolean {
  if (isR2HarnessRequested()) return false;
  const override = queryFlag();
  if (override !== null) return override;
  const env = envFlag();
  return env === null ? DEFAULT_R2_ENABLED : env;
}

/** ?r2=harness mounts the asset harness instead of the game. */
export function isR2HarnessRequested(): boolean {
  const raw = queryToken();
  return raw !== null && raw.trim().toLowerCase() === HARNESS_TOKEN;
}
